import {
  ApplicationRef,
  ComponentFactoryResolver,
  ComponentRef,
  Directive,
  ElementRef,
  EmbeddedViewRef,
  HostListener,
  Injector,
  Input,
  OnDestroy
} from '@angular/core';
import {DropdownListComponent} from './dropdown-list.component';
import {IDropdownListItem} from "./dropdown-list-item";

@Directive({
    selector: '[dbDropdownList]',
    standalone: false
})
export class DropdownListDirective implements OnDestroy {

  @Input('dbDropdownListPosition') position: 'top'|'bottom'|'left'|'right'|'dropdown' | 'right-with-gap'|'dropdown-payment-method';
  @Input('dbDropdownListDelay') delay: number;
  @Input('items') items: Array<IDropdownListItem>;
  @Input('item') item: any;
  @Input('toggleOnHover') toggleOnHover: boolean;
  @Input('className') className: string;
  private _dbDropdownListComponentRef: ComponentRef<DropdownListComponent>;
  private _mouseLeaveTimeout: any;

  constructor(
    private _element: ElementRef,
    private _applicationRef: ApplicationRef,
    private _injector: Injector,
    private _componentFactoryResolver: ComponentFactoryResolver
  ) {}

  @HostListener('click') mouseenter() {
    this.showDropdownList();
  }

  private showDropdownList(): void {
    if (this._dbDropdownListComponentRef) {
      return;
    }
    // create a dropdown component reference
    this._dbDropdownListComponentRef = this._componentFactoryResolver.resolveComponentFactory(DropdownListComponent).create(this._injector);
    this._dbDropdownListComponentRef.instance.host = this._element.nativeElement;
    this._dbDropdownListComponentRef.instance.items = this.items;
    this._dbDropdownListComponentRef.instance.item = this.item;
    this._dbDropdownListComponentRef.instance.position = this.position || 'top';
    this._dbDropdownListComponentRef.instance.className = this.className || '';
    this._dbDropdownListComponentRef.instance.toggleOnHover = this.toggleOnHover || false;
    this._dbDropdownListComponentRef.instance.delay = this.delay;
    this._dbDropdownListComponentRef.instance.cancelHideEvent.subscribe(event => {
      if ( event === 'show' ) {
        clearTimeout(this._mouseLeaveTimeout);
      }
      else {
        this.hideDropdownList();
      }
    });
    // attach component to the applicationRef so that it will be dirty checked.
    this._applicationRef.attachView(this._dbDropdownListComponentRef.hostView);

    // get DOM element from component
    const dropdownListComponentElement: HTMLElement = (this._dbDropdownListComponentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;

    document.body.appendChild(dropdownListComponentElement);
  }

  private hideDropdownList(): void {
    this._dbDropdownListComponentRef && this._dbDropdownListComponentRef.destroy();
    this._dbDropdownListComponentRef = null;
  }

  @HostListener('mouseleave') mouseleave() {
    this._mouseLeaveTimeout = setTimeout((): void => {
      this.hideDropdownList();
    }, 0 );
  }

  ngOnDestroy() {
    this.hideDropdownList();
  }

}
